import { v4 as uuidv4 } from 'uuid';

declare global {
  interface Window {
    fbq?: (command: string, eventName: string, data?: Record<string, unknown>, options?: { eventID?: string }) => void;
  }
}

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') {
    return undefined;
  }
  const cookies = document.cookie.split(';');
  for (const c of cookies) {
    const [key, ...rest] = c.trim().split('=');
    if (key === name) {
      const value = rest.join('=');
      return value !== '' ? value : undefined;
    }
  }
  return undefined;
}

export function getFbp(): string | undefined {
  return readCookie('_fbp');
}

export function getFbc(): string | undefined {
  return readCookie('_fbc');
}

export function generateEventId(): string {
  return uuidv4();
}

export function fbqTrack(eventName: string, data: Record<string, unknown>, eventId: string): void {
  if (typeof window === 'undefined' || window.fbq === undefined) {
    return;
  }
  window.fbq('track', eventName, data, { eventID: eventId });
}
